import { createApp, h } from "vue";
import { InertiaProgress } from "@inertiajs/progress";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Toast from "vue-toastification";
import { useToast } from "vue-toastification";
import format from "date-fns/format";
import "vue-toastification/dist/index.css";
import "tw-elements";
import "./icons";
import "./echo";
import VueApexCharts from "vue3-apexcharts";
import PrimeVue from "primevue/config";
import Tooltip from 'primevue/tooltip';


import { createPinia } from "pinia";

//theme
import "primevue/resources/themes/lara-light-indigo/theme.css";
//core
import "primevue/resources/primevue.min.css";
//icons
import "primeicons/primeicons.css";

const toast = useToast();
InertiaProgress.init();

const pinia = createPinia();

let userLogin = {
  username: "",
  password: "",
};

if (process.env.NODE_ENV !== "production") {
  userLogin = {
    username: process.env.MIX_DEV_USERNAME,
    password: process.env.MIX_DEV_PASSWORD,
  };
}

createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),
  title: (title) => (title ? `${title} - HAWK` : "HAWK"),
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) });

    app.config.globalProperties.$toast = toast;
    app.config.globalProperties.$user = userLogin;

    app.config.globalProperties.$filters = {
      formatDate(value, type) {
        if (typeof value == "undefined" || value == null) {
          return "";
        }
        if (typeof type != "string") {
          type = "dd/MM/yyyy";
        }
        if (typeof value != "object") {
          if (value.length <= 10) {
            value = value + " " + "00:00:00";
          }
          value = new Date(value);
        }
        return format(value, type);
      },
      formatDateTime(value, type) {
        if (typeof value == "undefined" || value == null) {
          return "";
        }
        if (typeof type != "string") {
          type = "dd/MM/yyyy HH:mm";
        }
        if (typeof value != "object") {
          value = new Date(value);
        }
        return format(value, type);
      },
      allowedChars(word, numbers, email, specials, space) {
        let allowed = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        allowed += "abcdefghijklmnopqrstuvwxyz";
        if (space === true) {
          allowed += " ";
        }
        if (numbers === true) {
          allowed += "0123456789";
        }
        if (email === true) {
          allowed += "-_@.";
        }
        if (specials === true) {
          allowed += "-";
        }
        let newWord = "";
        let char = "";
        for (let i = 0; i < word.length; i++) {
          char = word.substr(i, 1).toString();
          try {
            if (char !== "$") {
              if (allowed.indexOf(char) >= 0) {
                newWord += char;
              }
            }
          } catch (err) {}
        }
        return newWord.replace(/( )+/g, " ");
      },
    };

    app
      .component("font-awesome-icon", FontAwesomeIcon)
      .use(plugin)
      .use(Toast)
      .use(PrimeVue)
      .use(pinia)
      .directive('tooltip', Tooltip)
      .mount(el);

    app.use(VueApexCharts);
  },
});
